import { v4 as uuidv4 } from 'uuid';

export function prepareCloudEventPayload({
  type,
  subject,
  source,
  data,
}: {
  type: string;
  subject: string;
  source: string;
  data: Record<string, any>;
}) {
  const time = new Date().toISOString();
  return {
    id: uuidv4(),
    specversion: '1.0',
    datacontenttype: 'application/json',
    time,
    type,
    subject,
    source,
    data,
  };
}
